/**
 * Flatten markdown to plain text for one-line previews (conversation titles,
 * recent-list rows). The conversation list shows raw stored content — e.g. an
 * agent reply seeded as a title — which otherwise renders literal `**bold**`
 * and `- bullets`. This collapses that to readable single-line text.
 */
export function stripMarkdown(input: string): string {
  return input
    .replace(/```[\s\S]*?```/g, ' ') // fenced code blocks
    .replace(/`([^`]+)`/g, '$1') // inline code
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ') // images
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1') // links → text
    .replace(/^\s{0,3}#{1,6}\s+/gm, '') // headings
    .replace(/^\s*>\s?/gm, '') // blockquotes
    .replace(/^\s*[-*+]\s+/gm, '') // unordered list markers
    .replace(/^\s*\d+\.\s+/gm, '') // ordered list markers
    .replace(/(\*\*|__)(.*?)\1/g, '$2') // bold
    .replace(/\*([^*\n]+?)\*/g, '$1') // italic (asterisk only — spares identifiers)
    .replace(/~~(.*?)~~/g, '$1') // strikethrough
    .replace(/\s+/g, ' ') // collapse whitespace/newlines
    .trim();
}
